// src/utils/permissionHelper.js

/**
 * Centralized utility for role + plan-based permissions
 */

// Role-based: Check if user has a specific permission
export function hasPermission(user, responsibilityName, actionName) {
  if (!user || !user.roles) return false;
  if (user.roles.some(role => role.name === "SuperAdmin")) return true;

  const responsibility = responsibilityName?.toLowerCase();
  const actions = Array.isArray(actionName)
    ? actionName.map(a => a?.toLowerCase())
    : actionName ? [actionName?.toLowerCase()] : [];

  return user.roles.some(role =>
    role.responsibility?.some(res =>
      res.name?.toLowerCase() === responsibility &&
      res.actions?.some(
        action =>
          actions.includes(action.name?.toLowerCase()) &&
          action.enabled
      )
    )
  );
}

// Role-based: Check if user has a responsibility (ignoring actions)
export function hasResponsibility(user, responsibilityName) {
  if (!user || !user.roles) return false;
  if (user.roles.some(role => role.name === "SuperAdmin")) return true;

  return user.roles.some(role =>
    role.responsibility?.some(res =>
      res.name?.toLowerCase() === responsibilityName?.toLowerCase() &&
      res.enabled
    )
  );
}

// Plan-based: Check plan responsibility
export function hasPlanResponsibility(responsibilityName) {
  try {
    const planResponsibilities =
      JSON.parse(localStorage.getItem("planResponsibilities")) || [];
    return planResponsibilities.some(
      r => r && r.toLowerCase() === responsibilityName.toLowerCase()
    );
  } catch {
    return false;
  }
}

// Unified: Plan OR Role
export function hasAccess(user, responsibilityName, actionName = null) {
  // Plan responsibility → allow
  if (hasPlanResponsibility(responsibilityName)) return true;

  // Role + action check
  if (user) {
    if (actionName) {
      return hasPermission(user, responsibilityName, actionName);
    }
    return hasResponsibility(user, responsibilityName);
  }

  return false;
}

